import {
  getSessionStorageItem,
  removeSessionStorageItem,
  setSessionStorageItem
} from '../sessionStorage';

export const RETURN_URL_KEY = 'returnUrl';

const AUTH_AND_SPECIAL_PATHS = [
  '/reset-password/',
  '/sign-up-sales-new',
  '/sign-up',
  '/forgot-password',
  '/activate-member/',
  '/setup',
  '/connecting-stream-dsp',
  '/connecting-stream-pos',
  '/hubspot-chat',
  '/developer',
  '/login_token'
];

export const isValidReturnUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  if (!url.startsWith('/') || url.startsWith('//')) return false;

  const pathname = url.split('?')[0];
  if (pathname === '/') return false;

  return !AUTH_AND_SPECIAL_PATHS.some((item) => pathname.includes(item));
};

export const saveReturnUrl = (url) => {
  if (isValidReturnUrl(url)) {
    setSessionStorageItem(RETURN_URL_KEY, url);
  }
};

export const clearReturnUrl = () => {
  removeSessionStorageItem(RETURN_URL_KEY);
};

/**
 * Prefers streamUrl (existing OAuth flow), then returnUrl.
 * Removes both keys after read so stale redirects cannot leak.
 */
export const consumeReturnUrl = () => {
  const streamUrl = getSessionStorageItem('streamUrl');
  if (streamUrl) {
    removeSessionStorageItem('streamUrl');
    removeSessionStorageItem(RETURN_URL_KEY);
    return streamUrl;
  }

  const returnUrl = getSessionStorageItem(RETURN_URL_KEY);
  removeSessionStorageItem(RETURN_URL_KEY);

  if (isValidReturnUrl(returnUrl)) {
    return returnUrl;
  }

  return null;
};
